import { c as _c } from "react/compiler-runtime";
import { useEffect, useEffectEvent, useRef, useState } from 'react';
import type { MutableRefObject } from 'react';
interface UseWaveNameTruncationOptions {
  readonly collapsed: boolean;
  readonly contentKey: string;
}
interface UseWaveNameTruncationResult {
  readonly isNameTruncated: boolean;
  readonly nameRef: MutableRefObject<HTMLDivElement | null>;
}
export const useWaveNameTruncation = t0 => {
  const $ = _c(10);
  const {
    collapsed,
    contentKey
  } = t0;
  const nameRef = useRef(null);
  const [isNameTruncated, setIsNameTruncated] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const element = nameRef.current;
      if (!element) {
        return;
      }
      setIsNameTruncated(element.scrollWidth > element.clientWidth);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const measureTruncation = useEffectEvent(t1);
  let t2;
  if ($[1] !== collapsed || $[2] !== measureTruncation) {
    t2 = () => {
      if (collapsed) {
        setIsNameTruncated(false);
        return;
      }
      const element_0 = nameRef.current;
      if (!element_0) {
        return;
      }
      measureTruncation();
      let resizeObserver;
      if (typeof ResizeObserver !== "undefined") {
        resizeObserver = new ResizeObserver(() => {
          measureTruncation();
        });
        resizeObserver.observe(element_0);
      }
      window.addEventListener("resize", measureTruncation);
      return () => {
        window.removeEventListener("resize", measureTruncation);
        resizeObserver?.disconnect();
      };
    };
    $[1] = collapsed;
    $[2] = measureTruncation;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== collapsed || $[5] !== contentKey || $[6] !== measureTruncation) {
    t3 = [collapsed, contentKey, measureTruncation];
    $[4] = collapsed;
    $[5] = contentKey;
    $[6] = measureTruncation;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== isNameTruncated) {
    t4 = {
      isNameTruncated,
      nameRef
    };
    $[8] = isNameTruncated;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};